import { AfterViewInit, Component, Input, OnChanges } from '@angular/core';
import { InTimePipe } from 'src/app/_shared/pipes/in-time.pipe';
import { createPlotlyChart } from 'src/app/_shared/plotlyConfig';

@Component({
  selector: 'app-battery-condition-predicted-chart',
  templateUrl: './battery-condition-predicted-chart.component.html',
  styleUrls: ['./battery-condition-predicted-chart.component.scss']
})
export class BatteryConditionPredictedChartComponent implements OnChanges, AfterViewInit {
  @Input() fleetId: string[] = [];
  @Input() chartId: string = 'battery-condition-predicted-chart';
  @Input() dataLoadingBCEvents!: boolean;
  @Input() errorMessageBCEvents!: boolean;
  @Input() batteryConditions!: any;
  @Input() fleetStatus: any;
  errorMessagePredictedBatteryCondition: boolean = false;
  private viewReady = false;

  ngAfterViewInit(): void {
    this.viewReady = true;
    this.plotWhenReady();
  }

  ngOnChanges(): void {
    this.plotWhenReady();
  }

  private plotWhenReady(): void {
    if (this.viewReady && Object.keys(this.batteryConditions ?? {}).length !== 0) {
      this.plotBatteryCondition();
    }
  }

  plotBatteryCondition() {
    const data = Object.keys(this.batteryConditions).flatMap((fleetId: string) => {
      const plotData = this.batteryConditions[fleetId];
      if (!plotData) return {}
      const aboveCondition = plotData.batteryConditionPred.above;
      const averageCondition = plotData.batteryConditionPred.average;
      const belowCondition = plotData.batteryConditionPred.below;
      const undefinedCondition = plotData.batteryConditionPred.undefined;
      
      return {
        values: [aboveCondition, averageCondition, belowCondition, undefinedCondition],
        labels: ['Above average condition', 'Average condition', 'Below average condition', 'Rating still pending'],
        type: 'pie',
        marker: {
          colors: ['#00884A', '#007BC0', '#C535BC', '#B2B9C0']
        },
        hoverinfo: 'label+percent',
      }
    })

    if (data.every(d => Array.isArray(d.values) && d.values.every((v: any) => v === null))) {
      this.errorMessagePredictedBatteryCondition = true;
    } else {
      const inTime = new InTimePipe();
      let predictionLabel = '';
      if(this.fleetStatus[0]?.predictionDays !== null && this.fleetStatus[0]?.predictionDays !== undefined) {
        predictionLabel = inTime.transform(this.fleetStatus[0]?.predictionDays, true);
      } else {
        predictionLabel = 'In 1 year';
      }
      
      const layout = {
        title: `Fleet Battery Condition - Predicted (${predictionLabel})`,
        font: {
          family: 'boschsans, Helvetica Neue, Helvetica, Arial, sans-serif',
          size: 13,
        },
        showlegend: true,
        legend: {
          orientation: 'h', 
          y: -0.3, 
          xanchor: 'center', 
          x: 0.5,
          font: {
            family: 'boschsans, Helvetica Neue, Helvetica, Arial, sans-serif',
            size: 13, 
          },
          itemclick: false,
          itemdoubleclick: false,
        }
      };

      createPlotlyChart(this.chartId, data, layout);
    }
  }

}
